import { render, staticRenderFns } from "./cow-serial-table.vue?vue&type=template&id=cded28ee&"
import script from "./cow-serial-table.vue?vue&type=script&lang=js&"
export * from "./cow-serial-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports